import { useEffect, useState, useRef } from 'react';
import { UpdateLeadStage, appKanbanUserList, appSubmission, getCompanies, getLabel, getOpportunitiesList, getOpportunitiesListByStage, getPipelines, getSoftwareUsers, registeredUserList, BulkAddFollowers, BulkAddAssignedUsers } from '../../utils/urls';
import axios from '../../utils/axios';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AppsTable from '../../components/apps/appsTable';
import AppSectionList from '../../components/apps/appsKanban/AppSectionList';
import FlexComponent from '../../components/FlexComponent';
import './appLeads.css';
import { InputText } from 'primereact/inputtext';
import useDebounce from '../../components/apps/appsKanban/hooks/useDebounce';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Avatar } from 'primereact/avatar';
import { Badge } from 'primereact/badge';
import ArchivedAppsTable from '../../components/apps/ArchivedAppsTable';
import adminLogo from '../../Images/admin_img.jpg';
import { Calendar } from 'primereact/calendar';
import { CancelToken } from 'axios';
import { Dropdown } from 'primereact/dropdown';
import { ToggleButton } from 'primereact/togglebutton';
import AppModal from '../../shared/AppModal';

const INCOME_OPTIONS = {
    min: [
        { label: 'No Min', value: 0 },
        { label: '$25K', value: 25000 },
        { label: '$50K', value: 50000 },
        { label: '$75K', value: 75000 },
        { label: '$100K', value: 100000 },
        { label: '$150K', value: 150000 },
        { label: '$200K', value: 200000 },
        { label: '$250K', value: 250000 },
        { label: '$300K', value: 300000 },
        { label: '$400K', value: 400000 },
        { label: '$500K', value: 500000 },
        { label: '$750K', value: 750000 },
        { label: '$1M', value: 1000000 },
        { label: '$1.5M', value: 1500000 },
        { label: '$2M', value: 2000000 },
    ],
    max: [
        { label: '$25K', value: 25000 },
        { label: '$50K', value: 50000 },
        { label: '$75K', value: 75000 },
        { label: '$100K', value: 100000 },
        { label: '$150K', value: 150000 },
        { label: '$200K', value: 200000 },
        { label: '$250K', value: 250000 },
        { label: '$300K', value: 300000 },
        { label: '$400K', value: 400000 },
        { label: '$500K', value: 500000 },
        { label: '$750K', value: 750000 },
        { label: '$1M', value: 1000000 },
        { label: '$1.5M', value: 1500000 },
        { label: 'No Max', value: 2000000 },
    ],
};

const SAVINGS_OPTIONS = INCOME_OPTIONS;

const CREDIT_OPTIONS = {
    min: [
        { label: 'No Min', value: 0 },
        { label: '500', value: 500 },
        { label: '520', value: 520 },
        { label: '540', value: 540 },
        { label: '580', value: 580 },
        { label: '600', value: 600 },
        { label: '620', value: 620 },
        { label: '640', value: 640 },
        { label: '660', value: 660 },
        { label: '680', value: 680 },
        { label: '700', value: 700 },
        { label: '720', value: 720 },
        { label: '740', value: 740 },
        { label: '760', value: 760 },
        { label: '800', value: 800 },
        { label: '850', value: 850 },
        { label: '900', value: 900 },
        { label: '1000', value: 1000 },
    ],
    max: [
        { label: '500', value: 500 },
        { label: '520', value: 520 },
        { label: '540', value: 540 },
        { label: '580', value: 580 },
        { label: '600', value: 600 },
        { label: '620', value: 620 },
        { label: '640', value: 640 },
        { label: '660', value: 660 },
        { label: '680', value: 680 },
        { label: '700', value: 700 },
        { label: '720', value: 720 },
        { label: '740', value: 740 },
        { label: '760', value: 760 },
        { label: '800', value: 800 },
        { label: '850', value: 850 },
        { label: '900', value: 900 },
        { label: 'No Max', value: 1000 },
    ],
};

const APP_SCORE_OPTIONS = {
    min: [
        { label: 'No Min', value: 0 },
        { label: '10', value: 10 },
        { label: '20', value: 20 },
        { label: '30', value: 30 },
        { label: '40', value: 40 },
        { label: '50', value: 50 },
        { label: '60', value: 60 },
        { label: '70', value: 70 },
        { label: '80', value: 80 },
        { label: '90', value: 90 },
        { label: '100', value: 100 },
    ],
    max: [
        { label: '10', value: 10 },
        { label: '20', value: 20 },
        { label: '30', value: 30 },
        { label: '40', value: 40 },
        { label: '50', value: 50 },
        { label: '60', value: 60 },
        { label: '70', value: 70 },
        { label: '80', value: 80 },
        { label: '90', value: 90 },
        { label: 'No Max', value: 100 },
    ],
};

const AppKanban = () => {
    const { pipelineId } = useParams();
    const { table } = useParams();

    const isSuperuser = useSelector((state) => state.user.isSuperuser);
    const image = useSelector((state) => state.user.image);
    const userId = useSelector((state) => state.user.userId);

    const [loading, setLoading] = useState(false);
    const [isLastCommunicationFilter, setIsLastCommunicationFilter] = useState(false);
    const cancelTokenRef = useRef(null);
    const toast = useRef(null);
    const [isMounted, setIsMounted] = useState(false);

    const [boardSections, setBoardSections] = useState({
        "⏲️ Waiting/Follow Up": [],
        "🤳 Self-Serve Quick App": [],
        "📃✨ New Application": [],
        "🤖 Auto Doc Request": [],
        "🔥 Prequalified Awaiting Docs": [],
        "📄 Docs in - Active Client": [],
        "✅ Preapproved": [],
        "🛒Shopping": [],
        "📈 Refi": [],
        "✅ Active Loan": []
    });
    const [pipeline, setPipeline] = useState('');
    const [stageIds, setStageIds] = useState({});
    const [stageWatchers, setStageWatchers] = useState({});
    const [stageAppCounts, setStageAppCounts] = useState({});
    const [usersList, setUsersList] = useState([]);
    const [registeredUsersList, setRegisteredUsersList] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [softwareUsers, setSoftwareUsers] = useState([]);
    const [selectedApplicationByUsers, setSelectedApplicationByUsers] = useState([]);
    const [labels, setLabels] = useState([]);
    const [selectedLabels, setSelectedLabels] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [selectedCompanies, setSelectedCompanies] = useState([
    "Supreme Lending",
    "Vantage Realty Partners",
    "Homes For Sale Media",
    "Gold Coast Realty"
]);
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [dateRange, setDateRange] = useState([]);
    const [dueDateRange, setDueDateRange] = useState([])
    const [lastCommunicationRange, setLastCommunicationRange] = useState([]);
    const [dateRangeString, setDateRangeString] = useState('');
    const [dueDateRangeString, setDueDateRangeString] = useState('')
    const [lastCommunicationString, setLastCommunicationString] = useState('');
    const [incomeRangeValue, setIncomeRangeValue] = useState([0, 2000000]);
    const [creditRangeValue, setCreditRangeValue] = useState([0, 1000]);
    const [savingsRangeValue, setSavingsRangeValue] = useState([0, 2000000]);
    const [appScoreValue, setAppScoreValue] = useState([0, 100]);
    const [allPipelinesData, setAllPipelinesData] = useState([])
    const [initialStagesLoading, setInitialStagesLoading] = useState(true)
    // const [sortBy, setSortBy] = useState(() => {
    //     const savedView = localStorage.getItem('sortBy');
    //     return savedView ? JSON.parse(savedView) : "due_date";
    // });
    const [sortBy, setSortBy] = useState("due_date");
    const [isActive, setIsActive] = useState(true)

    // State for last communication filter
    const [lastCommunicationFilter, setLastCommunicationFilter] = useState({
        filter: '',
        unit: '',
        value: ''
    });
    // console.log("selectedCompanies", selectedCompanies);
    
    const debouncedSearchQuery = useDebounce(searchQuery, 300);
    const debouncedIncomeRange = useDebounce(incomeRangeValue, 300);
    const debounceCreditRange = useDebounce(creditRangeValue, 300);
    const debounceSavingsRange = useDebounce(savingsRangeValue, 300);
    const debounceAppScoreRange = useDebounce(appScoreValue, 300);
    const debouncedLastCommunicationFilter = useDebounce(lastCommunicationFilter, 300);
    const [isClearingFilters, setIsClearingFilters] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [stageLoading, setStageLoading] = useState({
        "⏲️ Waiting/Follow Up": true,
        "🤳 Self-Serve Quick App": true,
        "📃✨ New Application": true,
        "🤖 Auto Doc Request": true,
        "🔥 Prequalified Awaiting Docs": true,
        "📄 Docs in - Active Client": true,
        "✅ Preapproved": true,
        "🛒Shopping": true,
        "📈 Refi": true,
        "✅ Active Loan": true
    })

    const options = ['Board', 'Hot Leads', 'Table', 'Archived'];
    const [page, setPage] = useState(table ? options[1] : options[0]);
    const op = useRef(null);
    const [total, setTotal] = useState(0);
    const is_leader = useSelector((state) => state.user.is_leader);

    const [isSelectMode, setIsSelectMode] = useState(false);
    // Map<form_id, {form_id, ghl_contact_id}> — persists card identity across filter changes
    const [selectedCards, setSelectedCards] = useState(new Map());
    const [bulkFollowersDialog, setBulkFollowersDialog] = useState(false);
    const [selectedBulkFollowers, setSelectedBulkFollowers] = useState([]);
    const [selectedBulkContactOwner, setSelectedBulkContactOwner] = useState(null);
    const [isBulkSubmitting, setIsBulkSubmitting] = useState(false);

    const handleCardSelect = (app) => {
        setSelectedCards(prev => {
            const next = new Map(prev);
            if (next.has(app.form_id)) {
                next.delete(app.form_id);
            } else {
                // Store minimal identity so it survives filter changes
                next.set(app.form_id, { form_id: app.form_id, ghl_contact_id: app.ghl_contact_id });
            }
            return next;
        });
    };

    const exitSelectMode = () => {
        setIsSelectMode(false);
        setSelectedCards(new Map());
        setSelectedBulkFollowers([]);
        setSelectedBulkContactOwner(null);
    };

    const handleBulkAddFollowers = async () => {
        if (!selectedBulkFollowers.length && !selectedBulkContactOwner) return;
        if (!selectedCards.size) return;
        setIsBulkSubmitting(true);

        // Build payload directly from the Map — no boardSections lookup needed
        const contactIds = [];
        const appIds = {};
        const formIds = [];
        for (const [formId, cardData] of selectedCards) {
            contactIds.push(cardData.ghl_contact_id);
            appIds[cardData.ghl_contact_id] = formId;
            formIds.push(formId);
        }

        try {
            const promises = [];

            if (selectedBulkFollowers.length) {
                promises.push(
                    axios.post(BulkAddFollowers, {
                        contact_ids: contactIds,
                        selectedUsers: selectedBulkFollowers,
                        userId,
                        app_ids: appIds,
                    })
                );
            }

            if (selectedBulkContactOwner) {
                promises.push(
                    axios.post(BulkAddAssignedUsers, {
                        app_ids: formIds,
                        user: { id: selectedBulkContactOwner.id },
                    })
                );
            }

            await Promise.all(promises);

            // Optimistic UI update for followers
            if (selectedBulkFollowers.length) {
                const selectedFormIds = new Set(selectedCards.keys());
                setBoardSections(prevSections => {
                    const updatedSections = { ...prevSections };
                    for (const sectionId in updatedSections) {
                        updatedSections[sectionId] = updatedSections[sectionId].map(item => {
                            if (!selectedFormIds.has(item.form_id)) return item;
                            const updatedImages = [...item.images];
                            selectedBulkFollowers.forEach(user => {
                                if (!updatedImages.some(img => img.id === user.id)) {
                                    updatedImages.push({ ...user, roles: ['followers'] });
                                }
                            });
                            return { ...item, images: updatedImages };
                        });
                    }
                    return updatedSections;
                });
            }

            const parts = [];
            if (selectedBulkContactOwner) parts.push(`contact owner set to ${selectedBulkContactOwner.label}`);
            if (selectedBulkFollowers.length) parts.push(`followers added`);
            toast.current.show({ severity: 'success', summary: 'Success', detail: `${parts.join(' & ')} on ${selectedCards.size} card(s)`, life: 3000 });
            setBulkFollowersDialog(false);
            exitSelectMode();
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to update cards', life: 3000 });
        } finally {
            setIsBulkSubmitting(false);
        }
    };

    function getInitials(string) {
        let words = string?.split(' ');
        let initials = words?.map(word => word.charAt(0).toUpperCase());
        return initials?.join('');
    }

    const userTemplate = (option) => {
        return (
            <FlexComponent justifyContent="start">
                <Avatar image={option.image} size="small" label={<span style={{ padding: '5px' }}>{getInitials(option?.label)}</span>} shape="circle" style={{ marginRight: '8px' }} />
                <span>{option.label}</span>
            </FlexComponent>
        );
    };

    const labelsTemplate = (option) => {
        return (
            <FlexComponent justifyContent="center" style={{ height: "30px", width: "200px", background: `#${option.color}`, color: "white" }} >
                <p>{option.label}</p>
            </FlexComponent>
        );
    };


    const handleStageUpdate = (contact_id, form_id, stage, prevStage, emails, isLoad = false, stageId = "") => {
        const data = {
            userId: userId,
            stage_id: stageId ? stageId : stageIds[stage],
            email_list: emails
        };
        const stageUrl = `${UpdateLeadStage}${contact_id}/${form_id}`;
        axios.post(stageUrl, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Successfully Updated', life: 3000 });
                    if (isLoad) {
                        handleSearch(false);
                    }
                    setStageAppCounts(prevCounts => ({
                        ...prevCounts,
                        [stage]: prevCounts[stage] + 1,
                        [prevStage]: prevCounts[prevStage] - 1
                    }));
                    const url = `${appSubmission}${form_id}?pipelineId=${pipelineId}`;
                    axios.get(url, {
                        headers: { 'Content-Type': 'application/json' }
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                const data = response.data;
                                setBoardSections(prevSections => {
                                    const updatedSections = { ...prevSections };
                                    for (const sectionId in updatedSections) {
                                        updatedSections[sectionId] = updatedSections[sectionId].map(item => {
                                            if (item.form_id === form_id) {
                                                return {
                                                    ...item,
                                                    due_date: data.due_date
                                                };
                                            }
                                            return item;
                                        });
                                    }
                                    return updatedSections;
                                });
                            }
                        });
                } else if (response.status === 208) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.data, life: 3000 });
                    handleSearch();
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    handleSearch();
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                handleSearch();
            });
    };

    // console.log("pipleine----------", pipeline);

    const getAllPipelines = async () => {
        if (pipelineId) {
            const url = `${getPipelines}?userId=${userId}`;
            try {
                const response = await axios.get(url, {
                    headers: { 'Content-Type': 'application/json' }
                });
                if (response.status === 200) {
                    setAllPipelinesData(response.data);
                    const item = response.data.find(item => item.id == pipelineId);
                    setPipeline(item);
                    return item;
                }
            } catch (error) {
                console.error('Error fetching pipelines:', error);
            }
        }
    };

    const getSoftwareUsersFn = () => {
        const url = `${getSoftwareUsers}`;
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const options = response?.data?.map((user) => ({
                        // No `value` key — PrimeReact MultiSelect returns the full object
                        // when optionValue is not set and no `value` field exists.
                        label: user.full_name || user.username || '',
                        name:  user.full_name || user.username || '',
                        id:    user.ghl_user_id,   // GHL user_id expected by add_followers backend
                        image: user.image,
                    })) || [];
                    setSoftwareUsers(options);
                }
            })
            .catch((error) => { });
    };

    async function handleSearch(isLoad = true, isClearFilters = false) {
        if (!userId || !pipelineId) {
            console.error('Missing userId or pipelineId');
            setLoading(false);
            setIsClearingFilters(false);
            return;
        }

        if (isLoad) {
            setLoading(true);
        }

        if (cancelTokenRef.current) {
            cancelTokenRef.current.cancel('Operation canceled due to new request.');
        }
        cancelTokenRef.current = CancelToken.source();

        let incomeRange = "";
        let creditRange = "";
        let savingsRange = "";
        let appScore = "";

        if (!incomeRangeValue?.includes(0) || !incomeRangeValue?.includes(2000000)) {
            incomeRange = incomeRangeValue;
        }
        if (!creditRangeValue?.includes(0) || !creditRangeValue?.includes(1000)) {
            creditRange = creditRangeValue;
        }
        if (!savingsRangeValue?.includes(0) || !savingsRangeValue?.includes(2000000)) {
            savingsRange = savingsRangeValue;
        }
        if (!appScoreValue?.includes(0) || !appScoreValue?.includes(100)) {
            appScore = appScoreValue;
        }

        const isLastCommunicationFilterValid =
            lastCommunicationFilter?.filter &&
            lastCommunicationFilter?.unit &&
            lastCommunicationFilter?.value;

        try {
            let pipelineItem = ""
            // if (isInitialLoad) {
            pipelineItem = await getAllPipelines();
            // } else {
            //     pipelineItem = pipeline
            // }

            if (!pipelineItem || !pipelineItem.stages) {
                console.error('No pipelineItem or stages found:', pipelineItem);
                setBoardSections({});
                setStageAppCounts({});
                setTotal(0);
                setStageIds({});
                setStageWatchers({});
                setLoading(false);
                setIsClearingFilters(false);
                setIsInitialLoad(false);
                return;
            }

            const pipelineStages = pipelineItem.stages.sort((a, b) => a.position - b.position);
            // console.log('pipelineStages=====', pipelineStages);

            if (!pipelineStages.length) {
                console.warn('pipelineStages is empty');
                setBoardSections({});
                setStageAppCounts({});
                setTotal(0);
                setStageIds({});
                setStageWatchers({});
                setLoading(false);
                setIsClearingFilters(false);
                setIsInitialLoad(false);
                return;
            }

            const initialBoardSections = pipelineStages.reduce((acc, stage) => {
                acc[stage.name] = [];
                return acc;
            }, {});

            pipelineStages.map(({ name }) => {
                setStageLoading(prev => ({
                    ...prev,
                    [name]: true,
                }));
            })

            setBoardSections(initialBoardSections);
            setStageAppCounts({});
            setStageIds({});
            setStageWatchers({});
            setTotal(0);

            // let isFiltersExist = selectedUsers.length || selectedApplicationByUsers.length || selectedLanguages.length || selectedLabels.length || selectedCompanies.length || searchQuery;
            let isFilters = true;
            if (isClearFilters) {
                isFilters = false;
            }
            // console.log('isFilters:', isFilters);

            const queryParams = `&search=${searchQuery}&filterUser=${selectedUsers}&applicationByUser=${selectedApplicationByUsers}&language=${selectedLanguages}&labels=${selectedLabels}&company=${selectedCompanies}&income=${incomeRange}&credit=${creditRange}&available=${savingsRange}&dateRange=${dateRangeString}&dueDateRange=${dueDateRangeString}&lastCommunicationRange=${lastCommunicationString}&appScore=${appScore}&sortBy=${sortBy}&sort=ASC&limit=10&isActive=${isActive}`;

            let additionalParams = "";
            if (isLastCommunicationFilterValid) {
                additionalParams = `&lastCommunicationFilter=${lastCommunicationFilter.filter}&lastCommunicationUnit=${lastCommunicationFilter.unit}&lastCommunicationValue=${lastCommunicationFilter.value}`;
            }


            const baseUrl = `${getOpportunitiesListByStage}?userId=${userId}&pipelineId=${pipelineId}&stageId=`;
            setIsClearingFilters(false);
            const counts = [];
            const promises = pipelineStages.map((stage) => {
                const stageName = stage.name;
                const stageId = stage.id;
                let url = `${baseUrl}${encodeURIComponent(stageId)}${queryParams}${additionalParams}`;

                if (!isFilters) {
                    url = `${baseUrl}${encodeURIComponent(stageId)}&sort=ASC&limit=10`;
                }
                // console.log(`API URL for stage ${stage.id} (${stage.name}):`, url);

                return axios
                    .get(url, {
                        headers: { 'Content-Type': 'application/json' },
                        cancelToken: cancelTokenRef.current.token,
                    })
                    .then((response) => {
                        if (response.status === 200) {
                            setLoading(false);
                            const stageData = response.data[stageName] || [];
                            const mappedData = Array.isArray(stageData)
                                ? stageData.map((item) => ({ ...item, id: item.form_id }))
                                : [];

                            setBoardSections((prev) => ({
                                ...prev,
                                [stageName]: mappedData,
                            }));
                            setStageAppCounts((prev) => ({
                                ...prev,
                                [stageName]: response.data.count || 0,
                            }));
                            setStageIds((prev) => ({
                                ...prev,
                                [stageName]: stageId,
                            }));
                            setStageWatchers((prev) => ({
                                ...prev,
                                [stageName]: response.data.watchers || [],
                            }));
                            counts.push(response.data.count || 0); // Collect count
                        } else {
                            console.warn(`Non-200 status for stage ${stageName}:`, response.status);
                            setBoardSections((prev) => ({ ...prev, [stageName]: [] }));
                            setStageAppCounts((prev) => ({ ...prev, [stageName]: 0 }));
                            setStageIds((prev) => ({ ...prev, [stageName]: stageId }));
                            setStageWatchers((prev) => ({ ...prev, [stageName]: [] }));
                            counts.push(0); // Push 0 for non-200 responses
                        }
                    })
                    .catch((error) => {
                        if (axios.isCancel(error)) {
                            // console.log(`Request canceled for stage ${stageName}:`, error.message);
                            counts.push(0); // Push 0 for canceled requests
                            return;
                        }
                        console.error(`Error fetching data for stage ${stageName}:`, error);
                        setBoardSections((prev) => ({ ...prev, [stageName]: [] }));
                        setStageAppCounts((prev) => ({ ...prev, [stageName]: 0 }));
                        setStageIds((prev) => ({ ...prev, [stageName]: stageId }));
                        setStageWatchers((prev) => ({ ...prev, [stageName]: [] }));
                        counts.push(0); // Push 0 for errors
                    })
                    .finally(() => {
                        setStageLoading((prev) => ({
                            ...prev,
                            [stageName]: false,
                        }));
                        setInitialStagesLoading(false)
                    });
            });

            await Promise.allSettled(promises);

            // Calculate and set total after all promises settle
            const totalCount = counts.reduce((sum, count) => sum + count, 0);
            setTotal(totalCount);

            setIsInitialLoad(false);
            // }
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Request canceled:', error.message);
                return;
            }
            console.error('Error in handleSearch:', error);
            setBoardSections({});
            setStageAppCounts({});
            setTotal(0);
            setStageIds({});
            setStageWatchers({});
            setLoading(false);
            setIsClearingFilters(false);
            setIsInitialLoad(false);
        }
    }


    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const loadUsersData = () => {
        const url = `${appKanbanUserList}?userId=${userId}`;
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const options = response?.data?.map((user) => ({
                        label: user.name,
                        value: user.user_id,
                        image: user.image
                    })) || [];
                    setUsersList(options);
                }
            })
            .catch((error) => { });

        const registeredUsersUrl = `${registeredUserList}`;
        axios.get(registeredUsersUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const options = response?.data?.map((user) => ({
                        label: user.name,
                        value: user.user_id,
                        image: user.image
                    })) || [];
                    setRegisteredUsersList(options);
                }
            })
            .catch((error) => { });

        const labelsUrl = `${getLabel}`;
        axios.get(labelsUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const options = response?.data?.map((label) => ({
                        label: label.name,
                        value: label.id,
                        color: label.color
                    })) || [];
                    setLabels(options);
                }
            })
            .catch((error) => { });

        const companyUrl = `${getCompanies}`;
        axios.get(companyUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    const options = response?.data?.map((option) => ({
                        label: option.title,
                        value: option.title,
                    })) || [];
                    setCompanies(options);
                }
            })
            .catch((error) => { });
    };

    const clearFilters = () => {
        // console.log('clearFilters: isClearingFilters set to true');
        setIsClearingFilters(true);
        setSearchQuery('');
        setSelectedUsers([]);
        setSelectedApplicationByUsers([]);
        setSelectedLanguages([]);
        setSelectedLabels([]);
        setSelectedCompanies([]);
        setIncomeRangeValue([0, 2000000]);
        setAppScoreValue([0, 100]);
        setCreditRangeValue([0, 1000]);
        setSavingsRangeValue([0, 2000000]);
        setDateRange([]);
        setLastCommunicationRange([]);
        setDateRangeString('');
        setDueDateRangeString('')
        setLastCommunicationString('');
        setLastCommunicationFilter({ filter: '', unit: '', value: '' });
        setLoading(true);
        handleSearch(true, true);
    };

    // useEffect(()=> {

    // }, [isClearingFilters])

    useEffect(() => {
        if (userId && pipelineId && isInitialLoad) {
            setLoading(true);
            loadUsersData();
            getSoftwareUsersFn();
            if (userId == 99) {
                setSelectedUsers([
                    "wJkbQQbagbU6jrFgfSUl",
                    "Ifg74FqfbtWHC95uzhME",
                    "gSV6YhVq2gF8lnsHrzYP",
                    "IswqfTBczfJF7BUOm8pF",
                    "ARisaxpVQPwUnXOco19v"
                ]);
            } else if (userId == 87 || userId == 206) {
                setSelectedUsers([
                    "gSV6YhVq2gF8lnsHrzYP",
                    "TyvZ8x3ZhG8vzxmDYbk3",
                    "Mz480XDOlNyC2jK2FJGm",
                    "CqhNmmMUuVy1Eq5vHETJ",
                    "VyT8UjGuLkODwtlAmHEs",
                    "vXXIgp7pUDG6Zxl8iwlm",
                    "Ia2ZF3YDNTdmXT77CqgA",
                    "aByEKKko89e0DNiTbMez"
                ]);
            }
            handleSearch();
        }
    }, [userId, pipelineId]);

    useEffect(() => {
        if (userId && pipelineId && !isInitialLoad && !isClearingFilters) {
            if (cancelTokenRef.current) {
                cancelTokenRef.current.cancel('Operation canceled due to filter change.');
            }
            setLoading(true);
            handleSearch();
            localStorage.setItem('sortBy', JSON.stringify(sortBy));
        }
    }, [userId, pipelineId, selectedUsers, selectedApplicationByUsers, selectedLanguages, selectedLabels, selectedCompanies, debouncedSearchQuery, debouncedIncomeRange, debounceCreditRange, debounceSavingsRange, debounceAppScoreRange, dateRangeString, dueDateRangeString, lastCommunicationString, isLastCommunicationFilter, isMounted, sortBy, isActive])

    const handleRangeDates = (e) => {
        setDateRange(e.value);
        const formatDate = (date) => date.toLocaleDateString('en-CA');
        if (e.value[0] && e.value[1]) {
            let startDate = formatDate(e.value[0]);
            let endDate = formatDate(e.value[1]);
            let dateRangeData = `${startDate},${endDate}`;
            setDateRangeString(dateRangeData);
        }
    };

    const handleDueDateRangeDates = (e) => {
        setDueDateRange(e.value);
        const formatDate = (date) => date.toLocaleDateString('en-CA');
        if (e.value[0] && e.value[1]) {
            let startDate = formatDate(e.value[0]);
            let endDate = formatDate(e.value[1]);
            let dateRangeData = `${startDate},${endDate}`;
            setDueDateRangeString(dateRangeData);
        }
    };

    const handleLastCommunicationDates = (e) => {
        setLastCommunicationRange(e.value);
        const formatDate = (date) => date.toLocaleDateString('en-CA');
        if (e.value[0] && e.value[1]) {
            let startDate = formatDate(e.value[0]);
            let endDate = formatDate(e.value[1]);
            let dateRangeData = `${startDate},${endDate}`;
            setLastCommunicationString(dateRangeData);
        }
    };


    return (
        <>
            <Toast ref={toast} />
            <div
                className='kanbanContainer'
                style={{
                    paddingBottom: '2rem',
                    backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative'
                }}
            >
                <div
                    className='table-inner-div'
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 0
                    }}
                />
                {!table && <Button className='piplelineTitleMob' style={{ cursor: "auto", color: "white", background: "transparent", boxShadow: "none", border: "none", width: "100%" }} >{pipeline.name} {!loading && `- ${total}`}</Button>}
                <FlexComponent flexDirection="column">
                    <FlexComponent className='searchContainer ' gap="1rem" justifyContent="end" style={{ margin: '10px 20px 10px 0px' }} >
                        {page === 'Board' && !table && <>
                            {<Button className='piplelineTitle' style={{ cursor: "auto", color: "white", background: "transparent", boxShadow: "none", border: "none",  fontSize: "20px", fontWeight: "bold" }} >{pipeline.name} {!loading && `- ${total}`}</Button>}
                            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }} >
                                <ToggleButton onLabel="Active" offLabel="InActive" style={{color:"white", marginRight: "1rem", border: "none", background : isActive ? "green" : "grey", padding: "3px 15px 3px 15px" }} checked={isActive} onChange={(e) => setIsActive(e.value)}  />

                                <Button style={{background: "transparent", boxShadow: "none", border: "none", color: "white", padding: "0px 8px 0px 0px" }} >Sort By:</Button>
                                <Dropdown
                                    value={sortBy}
                                    options={[
                                        { label: "Submitted At", value: "submitted_at" },
                                        { label: "Due Date", value: "due_date" }
                                    ]}
                                    onChange={(e) => {
                                        setSortBy(e.value);
                                    }}
                                    placeholder="Select SortBy"
                                    className='sortByDropdown'
                                    style={{ minWidth: "120px", color: 'black', padding: "0px" }}
                                />

                                {(isSuperuser || is_leader) && (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', background: 'rgba(255,255,255,0.06)', borderRadius: '8px', padding: '3px' }}>
                                        <Button
                                            type="button"
                                            onClick={() => { isSelectMode ? exitSelectMode() : setIsSelectMode(true); }}
                                            style={{
                                                boxShadow: 'none', borderRadius: '6px',
                                                background: isSelectMode ? '#1e6fd9' : 'transparent',
                                                color: 'white', border: 'none',
                                                padding: '6px 12px', fontSize: '13px', gap: '6px',
                                                transition: 'background 0.15s',
                                            }}
                                        >
                                            <i className="pi pi-check-square"></i>
                                            {isSelectMode ? `Selected (${selectedCards.size})` : 'Select'}
                                        </Button>
                                        {isSelectMode && selectedCards.size > 0 && (
                                            <Button
                                                type="button"
                                                onClick={() => setBulkFollowersDialog(true)}
                                                style={{
                                                    boxShadow: 'none', borderRadius: '6px',
                                                    background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                                                    color: 'white', border: 'none',
                                                    padding: '6px 14px', fontSize: '13px', gap: '6px',
                                                    fontWeight: '600',
                                                }}
                                            >
                                                <i className="pi pi-users"></i>
                                                Add
                                                <span style={{ background: 'rgba(255,255,255,0.25)', borderRadius: '20px', padding: '1px 7px', fontSize: '12px', fontWeight: '700' }}>
                                                    {selectedCards.size}
                                                </span>
                                            </Button>
                                        )}
                                    </div>
                                )}
                                <div>
                                <Button type="button" onClick={(e) => op.current.toggle(e)} style={{ boxShadow: "none", borderRadius: '0', paddingRight: (searchQuery.trim() || selectedUsers?.length > 0 || selectedApplicationByUsers?.length > 0 || selectedLanguages?.length > 0 || selectedCompanies?.length > 0 || selectedLabels?.length > 0 || (dateRange[0] && dateRange[1]) || (dueDateRange[0] && dueDateRange[1]) || (lastCommunicationRange[0] && lastCommunicationRange[1]) || (!incomeRangeValue?.includes(0) || !incomeRangeValue?.includes(2000000)) || (!creditRangeValue?.includes(0) || !creditRangeValue?.includes(1000)) || (!savingsRangeValue?.includes(0) || !savingsRangeValue?.includes(2000000)) || (!appScoreValue?.includes(0) || !appScoreValue?.includes(100)) || (lastCommunicationFilter.filter && lastCommunicationFilter.unit && lastCommunicationFilter.value)) && "5px" }} >
                                    <svg width="24" height="24" role="presentation" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M4.61799 6C3.87461 6 3.39111 6.78231 3.72356 7.44721L3.99996 8H20L20.2763 7.44721C20.6088 6.78231 20.1253 6 19.3819 6H4.61799ZM10.8618 17.7236C10.9465 17.893 11.1196 18 11.309 18H12.6909C12.8803 18 13.0535 17.893 13.1382 17.7236L14 16H9.99996L10.8618 17.7236ZM17 13H6.99996L5.99996 11H18L17 13Z" fill="currentColor"></path></svg>
                                    Filter
                                    {(searchQuery?.trim() || selectedUsers?.length > 0 || selectedApplicationByUsers?.length > 0 || selectedLanguages?.length > 0 || selectedCompanies?.length > 0 || selectedLabels?.length > 0 || (dateRange[0] && dateRange[1]) || (dueDateRange[0] && dueDateRange[1]) || (lastCommunicationRange[0] && lastCommunicationRange[1]) || (!incomeRangeValue?.includes(0) || !incomeRangeValue?.includes(2000000)) || (!creditRangeValue?.includes(0) || !creditRangeValue?.includes(1000)) || (!savingsRangeValue?.includes(0) || !savingsRangeValue?.includes(2000000)) || (!appScoreValue?.includes(0) || !appScoreValue?.includes(100)) || (lastCommunicationFilter.filter && lastCommunicationFilter.unit && Boolean(lastCommunicationFilter.value))) && <Badge style={{ marginTop: "4px" }} value={!loading && total} severity="info">{!loading && total}</Badge>}
                                </Button>
                                {(searchQuery?.trim() || selectedUsers?.length > 0 || selectedApplicationByUsers?.length > 0 || selectedLanguages?.length > 0 || selectedCompanies?.length > 0 || selectedLabels?.length > 0 || (dateRange[0] && dateRange[1]) || (dueDateRange[0] && dueDateRange[1]) || (lastCommunicationRange[0] && lastCommunicationRange[1]) || (!incomeRangeValue?.includes(0) || !incomeRangeValue?.includes(2000000)) || (!creditRangeValue?.includes(0) || !creditRangeValue?.includes(1000)) || (!savingsRangeValue?.includes(0) || !savingsRangeValue?.includes(2000000)) || (!appScoreValue?.includes(0) || !appScoreValue?.includes(100)) || (lastCommunicationFilter.filter && lastCommunicationFilter.unit && Boolean(lastCommunicationFilter.value))) && <Button style={{ boxShadow: "none", padding: "13px", borderRadius: '0', paddingLeft: "0" }} onClick={clearFilters} >Clear All</Button>}
                                </div>
                            </div>
                            <OverlayPanel ref={op} style={{ background: '#1A2B53', }} >
                                <div className='applicantDivs filterPopup' style={{ width: '25vw', height: '60vh', overflowY: "auto" }} >
                                    <FlexComponent flexDirection="column" gap="1rem" style={{ marginBottom: "1rem" }} >
                                        <div className='applicantDivs' style={{ width: "90%" }} >
                                            <p style={{ color: "white", marginBottom: ".5rem" }} >Keyword</p>
                                            <span className="p-input-icon-left " >
                                                <i className="pi pi-search" />
                                                <InputText type="search" placeholder='Enter a Keyword...' onChange={handleSearchChange} value={searchQuery} style={{ color: 'black' }} />
                                            </span>
                                            <p style={{ fontSize: "12px", color: "white", marginTop: "5px" }} >Search Location names, Contact names and more</p>
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }} >Members</p>
                                            <MultiSelect
                                                value={selectedUsers}
                                                options={usersList}
                                                itemTemplate={userTemplate}
                                                style={{ width: '100%', color: 'black' }}
                                                onChange={(event) => {
                                                    setSelectedUsers(event.value);
                                                    setLoading(true);
                                                }}
                                                placeholder='Select Members'
                                                filter
                                            />
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }} >Application By</p>
                                            <MultiSelect
                                                value={selectedApplicationByUsers}
                                                options={usersList}
                                                itemTemplate={userTemplate}
                                                style={{ width: '100%', color: 'black' }}
                                                onChange={(event) => {
                                                    setSelectedApplicationByUsers(event.value);
                                                    setLoading(true);
                                                }}
                                                placeholder='Select Members'
                                                filter
                                            />
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }} >Language</p>
                                            <MultiSelect
                                                value={selectedLanguages}
                                                options={[
                                                    { label: "English", value: "English" },
                                                    { label: "Spanish", value: "Spanish" },
                                                    { label: "Spanish & Some English", value: "Spanish and Some English" },
                                                    { label: "Other", value: "Other" }
                                                ]}
                                                style={{ width: '100%', color: 'black' }}
                                                onChange={(event) => {
                                                    setSelectedLanguages(event.value);
                                                    setLoading(true);
                                                }}
                                                placeholder='Select Language'
                                            />
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }} >Company</p>
                                            <MultiSelect
                                                value={selectedCompanies}
                                                options={companies}
                                                style={{ width: '100%', color: 'black' }}
                                                onChange={(event) => {
                                                    setSelectedCompanies(event.value);
                                                    setLoading(true);
                                                }}
                                                placeholder='Select Company'
                                            />
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }} >Labels</p>
                                            <MultiSelect
                                                value={selectedLabels}
                                                options={labels}
                                                itemTemplate={labelsTemplate}
                                                style={{ width: '100%', color: 'black' }}
                                                onChange={(event) => {
                                                    setSelectedLabels(event.value);
                                                    setLoading(true);
                                                }}
                                                placeholder='Select Labels'
                                            />
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }} >Due Date Range</p>
                                            <Calendar placeholder='Select Dates' style={{ width: "100%" }} value={dueDateRange || []} onChange={(e) => handleDueDateRangeDates(e)} selectionMode="range" />
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }} >Date Range</p>
                                            <Calendar placeholder='Select Dates' style={{ width: "100%" }} value={dateRange || []} onChange={(e) => handleRangeDates(e)} selectionMode="range" />
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }} >Last Communication Filter</p>
                                            <FlexComponent gap="0.5rem" flexDirection="column" >
                                                <Dropdown
                                                    value={lastCommunicationFilter.filter}
                                                    options={[
                                                        { label: "Less Than", value: "less_than" },
                                                        { label: "More Than", value: "more_than" }
                                                    ]}
                                                    onChange={(e) => {
                                                        setLastCommunicationFilter({ ...lastCommunicationFilter, filter: e.value });
                                                        if (e.value && lastCommunicationFilter.unit && lastCommunicationFilter.value) {
                                                            setLoading(true);
                                                            setIsLastCommunicationFilter(!isLastCommunicationFilter)
                                                        }
                                                    }}
                                                    placeholder="Select Filter"
                                                    style={{ width: '100%', color: 'black' }}
                                                />
                                                <FlexComponent gap=".75rem" >
                                                    <InputText
                                                        value={lastCommunicationFilter.value}
                                                        onChange={(e) => {
                                                            const inputValue = e.target.value;
                                                            // Only allow non-negative numbers
                                                            if (/^\d*$/.test(inputValue)) {
                                                                setLastCommunicationFilter({
                                                                    ...lastCommunicationFilter,
                                                                    value: inputValue === '' ? '' : parseInt(inputValue)
                                                                });
                                                                if (lastCommunicationFilter.filter && lastCommunicationFilter.unit && inputValue > 0) {
                                                                    setLoading(true);
                                                                    setIsLastCommunicationFilter(!isLastCommunicationFilter)
                                                                }
                                                            }
                                                        }}
                                                        placeholder="Input"
                                                        style={{ width: '40%' }}
                                                    />

                                                    <Dropdown
                                                        value={lastCommunicationFilter.unit}
                                                        options={[
                                                            { label: "Minute", value: "minute" },
                                                            { label: "Hour", value: "hour" },
                                                            { label: "Day", value: "day" },
                                                            { label: "Month", value: "month" },
                                                            { label: "Year", value: "year" }
                                                        ]}
                                                        onChange={(e) => {
                                                            // console.log(lastCommunicationFilter);
                                                            setLastCommunicationFilter({ ...lastCommunicationFilter, unit: e.value });
                                                            if (lastCommunicationFilter.filter && e.value && lastCommunicationFilter.value) {
                                                                setLoading(true);
                                                                setIsLastCommunicationFilter(!isLastCommunicationFilter)
                                                            }
                                                        }}
                                                        placeholder="Select Unit"
                                                        style={{ width: '60%', color: 'black' }}
                                                    />

                                                </FlexComponent>
                                            </FlexComponent>
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }} >Last Communication Range</p>
                                            <Calendar placeholder='Select Dates' style={{ width: "100%" }} value={lastCommunicationRange || []} onChange={(e) => handleLastCommunicationDates(e)} selectionMode="range" />
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }}>Income Range</p>
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                <Dropdown
                                                    value={incomeRangeValue[0]}
                                                    options={INCOME_OPTIONS.min.filter(o => o.value <= incomeRangeValue[1])}
                                                    onChange={(e) => setIncomeRangeValue([e.value, incomeRangeValue[1]])}
                                                    style={{ flex: 1, color: 'black' }}
                                                />
                                                <Dropdown
                                                    value={incomeRangeValue[1]}
                                                    options={INCOME_OPTIONS.max.filter(o => o.value >= incomeRangeValue[0])}
                                                    onChange={(e) => setIncomeRangeValue([incomeRangeValue[0], e.value])}
                                                    style={{ flex: 1, color: 'black' }}
                                                />
                                            </div>
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }}>Credit Range</p>
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                <Dropdown
                                                    value={creditRangeValue[0]}
                                                    options={CREDIT_OPTIONS.min.filter(o => o.value <= creditRangeValue[1])}
                                                    onChange={(e) => setCreditRangeValue([e.value, creditRangeValue[1]])}
                                                    style={{ flex: 1, color: 'black' }}
                                                />
                                                <Dropdown
                                                    value={creditRangeValue[1]}
                                                    options={CREDIT_OPTIONS.max.filter(o => o.value >= creditRangeValue[0])}
                                                    onChange={(e) => setCreditRangeValue([creditRangeValue[0], e.value])}
                                                    style={{ flex: 1, color: 'black' }}
                                                />
                                            </div>
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }}>Available Range</p>
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                <Dropdown
                                                    value={savingsRangeValue[0]}
                                                    options={SAVINGS_OPTIONS.min.filter(o => o.value <= savingsRangeValue[1])}
                                                    onChange={(e) => setSavingsRangeValue([e.value, savingsRangeValue[1]])}
                                                    style={{ flex: 1, color: 'black' }}
                                                />
                                                <Dropdown
                                                    value={savingsRangeValue[1]}
                                                    options={SAVINGS_OPTIONS.max.filter(o => o.value >= savingsRangeValue[0])}
                                                    onChange={(e) => setSavingsRangeValue([savingsRangeValue[0], e.value])}
                                                    style={{ flex: 1, color: 'black' }}
                                                />
                                            </div>
                                        </div>
                                        <div className='applicantDivs' style={{ width: "90%" }}>
                                            <p style={{ color: "white", marginBottom: ".5rem" }}>App Score Range</p>
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                <Dropdown
                                                    value={appScoreValue[0]}
                                                    options={APP_SCORE_OPTIONS.min.filter(o => o.value <= appScoreValue[1])}
                                                    onChange={(e) => setAppScoreValue([e.value, appScoreValue[1]])}
                                                    style={{ flex: 1, color: 'black' }}
                                                />
                                                <Dropdown
                                                    value={appScoreValue[1]}
                                                    options={APP_SCORE_OPTIONS.max.filter(o => o.value >= appScoreValue[0])}
                                                    onChange={(e) => setAppScoreValue([appScoreValue[0], e.value])}
                                                    style={{ flex: 1, color: 'black' }}
                                                />
                                            </div>
                                        </div>
                                    </FlexComponent>
                                </div>
                            </OverlayPanel>
                        </>}
                        <div className='appKanbanButtons' >
                            {!table && <Button style={{ borderTopRightRadius: "0", borderBottomRightRadius: "0", fontWeight: "600", background: page === 'Board' ? '#06243B' : 'white', color: page === 'Board' ? 'white' : 'black' }} onClick={() => {
                                setPage('Board');
                                handleSearch();
                            }}>Board</Button>}
                            <Button style={{ borderTopLeftRadius: "0", borderRadius: "0", fontWeight: "600", background: page === 'Hot Leads' ? '#06243B' : 'white', color: page === 'Hot Leads' ? 'white' : 'black' }} onClick={() => {
                                setPage('Hot Leads');
                            }}>Hot Leads</Button>
                            <Button style={{ borderTopLeftRadius: "0", borderRadius: isSuperuser ? "0" : "0 .5rem .6rem 0", fontWeight: "600", background: page === 'Table' ? '#06243B' : 'white', color: page === 'Table' ? 'white' : 'black' }} onClick={() => {
                                setPage('Table');
                            }}>Table</Button>
                            {isSuperuser && <Button style={{ borderRadius: "0 .5rem .6rem 0", fontWeight: "600", background: page === 'Archived' ? '#06243B' : 'white', color: page === 'Archived' ? 'white' : 'black' }} onClick={() => {
                                setPage('Archived');
                            }}>Archived</Button>}
                        </div>
                    </FlexComponent>
                    {page === 'Board' ? <FlexComponent flexDirection="column" className='applicant-cards' alignItems='start' gap="0.2rem" style={{ zIndex: '1' }}  >
                        <FlexComponent flexDirection='column' style={{ gap: '2rem', zIndex: '1', width: 'auto' }}>
                            <AppSectionList
                                key={loading}
                                toast={toast}
                                userId={userId}
                                pipeline={pipeline}
                                allPipelinesData={allPipelinesData}
                                softwareUsers={softwareUsers}
                                usersList={registeredUsersList}
                                setTotal={setTotal}
                                language={selectedLanguages}
                                labels={selectedLabels}
                                dateRange={dateRangeString}
                                dueDateRange = {dueDateRangeString}
                                lastCommunicationRange={lastCommunicationString}
                                lastCommunicationFilter={lastCommunicationFilter}
                                companies={selectedCompanies}
                                incomeRangeValue={incomeRangeValue}
                                creditRangeValue={creditRangeValue}
                                savingsRangeValue={savingsRangeValue}
                                appScoreValue={appScoreValue}
                                stageAppCounts={stageAppCounts}
                                stageIds={stageIds}
                                stageWatchers={stageWatchers}
                                setStageAppCounts={setStageAppCounts}
                                selectedUsers={selectedUsers}
                                selectedApplicationByUsers={selectedApplicationByUsers}
                                boardSections={boardSections}
                                setBoardSections={setBoardSections}
                                handleStageUpdate={handleStageUpdate}
                                searchQuery={searchQuery}
                                sortBy={sortBy}
                                isActive = {isActive}
                                isMounted={isMounted}
                                setIsMounted={setIsMounted}
                                loading={loading}
                                stageLoading={stageLoading}
                                isSelectMode={isSelectMode}
                                selectedCards={selectedCards}
                                onCardSelect={handleCardSelect}
                            />
                        </FlexComponent>
                    </FlexComponent>
                        : page === 'Hot Leads' ?
                            <AppsTable userId={userId} isHotLeads={true} />
                            : page === 'Table' ?
                                <AppsTable userId={userId} />
                                : <ArchivedAppsTable userId={userId} />
                    }
                </FlexComponent>
            </div>

            <AppModal
                header={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ background: 'linear-gradient(135deg, #2563eb, #1d4ed8)', borderRadius: '8px', width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="pi pi-users" style={{ color: 'white', fontSize: '14px' }}></i>
                        </div>
                        <div>
                            <div style={{ fontWeight: 700, fontSize: '15px', color: 'white' }}>Assign Users</div>
                            <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.45)', fontWeight: 400 }}>{selectedCards.size} card{selectedCards.size !== 1 ? 's' : ''} selected</div>
                        </div>
                    </div>
                }
                visible={bulkFollowersDialog}
                panelStyle={{ width: '440px' }}
                onHide={() => { setBulkFollowersDialog(false); setSelectedBulkFollowers([]); setSelectedBulkContactOwner(null); }}
                footer={
                    <div style={{ background: 'transparent', borderTop: '1px solid rgba(255,255,255,0.08)', padding: '0.625rem 1.25rem', display: 'flex', justifyContent: 'flex-end', gap: '6px' }}>
                        <Button
                            label="Cancel"
                            onClick={() => { setBulkFollowersDialog(false); setSelectedBulkFollowers([]); setSelectedBulkContactOwner(null); }}
                            style={{ boxShadow: 'none', background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.7)', borderRadius: '6px', padding: '5px 14px', fontSize: '13px' }}
                        />
                        <Button
                            label={isBulkSubmitting ? 'Adding…' : `Add to ${selectedCards.size} card${selectedCards.size !== 1 ? 's' : ''}`}
                            icon={isBulkSubmitting ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
                            disabled={(!selectedBulkFollowers.length && !selectedBulkContactOwner) || isBulkSubmitting}
                            onClick={handleBulkAddFollowers}
                            style={{ boxShadow: 'none', background: 'linear-gradient(135deg, #2563eb, #1d4ed8)', border: 'none', borderRadius: '6px', fontWeight: 600, padding: '5px 14px', fontSize: '13px' }}
                        />
                    </div>
                }
            >
                <div>
                    {/* Contact Owner */}
                    <div style={{ marginBottom: '1.25rem' }}>
                        <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', color: 'rgba(255,255,255,0.7)', fontWeight: 600 }}>
                            Contact Owner
                        </label>
                        <Dropdown
                            value={selectedBulkContactOwner}
                            onChange={e => setSelectedBulkContactOwner(e.value)}
                            options={softwareUsers}
                            optionLabel="label"
                            itemTemplate={userTemplate}
                            filter
                            showClear
                            placeholder="Select contact owner…"
                            style={{ width: '100%' }}
                        />
                    </div>

                    {/* Divider */}
                    <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', marginBottom: '1.25rem' }} />

                    {/* Followers */}
                    <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', color: 'rgba(255,255,255,0.7)', fontWeight: 600 }}>
                        Followers
                    </label>

                    {selectedBulkFollowers.length > 0 && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '0.75rem', padding: '8px 10px', background: 'rgba(255,255,255,0.05)', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.08)' }}>
                            {selectedBulkFollowers.map((follower) => (
                                <span key={follower.id} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', background: 'rgba(37,99,235,0.25)', border: '1px solid rgba(37,99,235,0.45)', borderRadius: '20px', padding: '3px 10px', fontSize: '12px', color: 'white' }}>
                                    {follower.label || follower.name}
                                    <i
                                        className="pi pi-times"
                                        style={{ fontSize: '10px', cursor: 'pointer', color: 'rgba(255,255,255,0.6)', marginLeft: '2px' }}
                                        onClick={() => setSelectedBulkFollowers(prev => prev.filter(v => v.id !== follower.id))}
                                    />
                                </span>
                            ))}
                        </div>
                    )}

                    <MultiSelect
                        value={selectedBulkFollowers}
                        onChange={(e) => setSelectedBulkFollowers(e.value)}
                        options={softwareUsers}
                        optionLabel="label"
                        filter
                        placeholder="Search and select followers…"
                        style={{ width: '100%' }}
                        display="comma"
                        maxSelectedLabels={0}
                        selectedItemsLabel="{0} followers selected"
                    />
                </div>
            </AppModal>
        </>
    );
};

export default AppKanban;